import { categoryCodeTab } from '@/layout/state/state';
import userGroupTabTemplate from './userGroupTabTemplate';

export default {
  ...userGroupTabTemplate(['usergroups', 'usergroup'], ({ usergroups }) => usergroups.create),
  componentState: ({ args, url }) => categoryCodeTab(url, args[4]),
};
